import classNames from "classnames";

import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "././AscJobBoardCompanyCard.module.scss";
import { UsersIcon } from "../../AscIcons";
import AscTag from "../../AscTag/AscTag";
import AscLink from "../../AscLink/AscLink";
import PlaceHolderImage from "../../../assets/images/place-holder-image.svg";
import { ReactComponent as BrowserSvg } from "../../../assets/icons/link.svg";
import AscRichTextViewer from "../../AscRichTextEditor/AscRichTextViewer/AscRichTextViewer";
import AscImage from "../../AscImage/AscImage";

export interface AscJobBoardCompanyCardProps {
  companyName: string;
  logoUrl?: string;
  link: string;
  companySize: string;
  description: string;
  tags?: { tag: string }[];
}

export default function AscJobBoardCompanyCard({
  companyName,
  logoUrl,
  companySize,
  description,
  tags,
  link,
}: AscJobBoardCompanyCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground)}
      bodyClassName={styles.cardBody}
      title={
        <AscParagraph className={styles.cardTitle}>{companyName}</AscParagraph>
      }
      customImage={
        <div className={styles.cardImageWrapper}>
          <div className={styles.cardImage}>
            <AscImage src={logoUrl || PlaceHolderImage} alt={companyName} />
            <AscLink
              className={styles.cardLink}
              innerWrapperTag={null}
              href={link}
              target="_blank"
            >
              <BrowserSvg />
            </AscLink>
          </div>
        </div>
      }
      footer={
        <div className={styles.cardFooter}>
          <AscParagraph className={styles.cardFooterTitle}>
            Company details
          </AscParagraph>
          <div className={styles.cardFooterContent}>
            <div className={styles.companySize}>
              <UsersIcon className={styles.icon} />
              <AscParagraph className={styles.priceCoins}>
                {companySize}
              </AscParagraph>
            </div>
            <div className={styles.tags}>
              {tags?.map((tag, index) => (
                <AscTag key={index} label={tag.tag} />
              ))}
            </div>
          </div>
        </div>
      }
    >
      {description && (
        <AscRichTextViewer
          className={styles.cardDescription}
          inferValue={description}
        />
      )}
    </AscGenericCard>
  );
}
